import DEV from './config.dev';
import LOCAL from './config.local';
import TEST from './config.test';
import SANDBOX from './config.sandbox';
import PRO from './config.pro';

var CACHE = { DEV, LOCAL, TEST, SANDBOX, PRO };

// 根据编译配置是否Debug
const DEBUG = process.env.VUE_APP_MODE;

// 组装配置文件
let CONFIG = Object.assign({}, {
    REQUEST_SUCCESS_CODE: 0,
    REQUEST_SUCCESS_CODE_1: 1,
    REQUEST_SUCCESS_CODE_2: 200,
    AUTH_ERROR_CODE: 600,
    DEBUG,
    PREFIX: 'TC_',
    AJAX_REQUEST_BASE: '',
    SPLIT: '-{}-'
}, CACHE[DEBUG]);

export default CONFIG;
